import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type PoDeleteParams = {
  uuid: string
}

export const usePoDeleteMutation = () =>
  useMutation<any, ErrorDTO, PoDeleteParams>({
    mutationFn: async (params) => {
      try {
        const res = await client.delete(`/po/delete/${params.uuid}`)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
